import { useMediaQuery, useTheme } from "@mui/material";
import { UiGrid } from "@smp/ui";

import { Details } from "./details";
import { Invoice } from "./invoice";
import { Periods } from "./periods";
import { Providers } from "./providers";
import { Recurring } from "./recurring";
import { Warnings } from "./warnings";

export const Prepare = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <UiGrid
      container
      spacing={2}
      flexWrap={isMobile ? "wrap" : "nowrap"}
      flexDirection={isMobile ? "column" : "row"}
    >
      <UiGrid item xs>
        <Periods />
        <Recurring />
        <Invoice />
        <Providers />
        <Warnings />
      </UiGrid>

      <UiGrid item>
        <Details />
      </UiGrid>
    </UiGrid>
  );
};
